import { Typography } from "@mui/material";
import { DescricaoSeguro } from "../../../interfaces/entities/SeguroViagem/DescricaoSeguro";
import './styles.css';
import { sxTypographyAdvice } from "./sxProps";
import parse from 'html-react-parser';
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

const ContatosSeguroInternacional: React.FC<{ lstDescricaoDetalhe?: DescricaoSeguro[]; }> = ({ lstDescricaoDetalhe }) => {

  const accessibility = useAccessibility();

  return (
    <div className='seguro-advice-container' style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
      {lstDescricaoDetalhe?.map((descricaoDetalhe) => (
        <Typography sx={sxTypographyAdvice} style={accessibility.textStyleAccessibility}>
          {parse(descricaoDetalhe.descricao)}
        </Typography>
      ))
      }
    </div>
  )
}

export default ContatosSeguroInternacional;